import htmx from 'htmx.org';

// Wie bei den Marketingboxen: verdeckt laden und die ganze Box erst fertig anzeigen.
const iwwMostReadSelector = '[data-iww-mostread]';
const iwwMostReadInitialized = new WeakSet();

async function iwwMostReadLoad(element) {
    if (iwwMostReadInitialized.has(element)) return;
    iwwMostReadInitialized.add(element);
    const box = element.closest('[data-iww-mostread-box]') || element.closest('section') || element;
    box.hidden = true;
    box.style.display = 'none';

    try {
        const source = element.getAttribute('data-mostread-url');
        if (!source) throw new Error('MostRead-URL fehlt');
        const url = new URL(source, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Ungueltige MostRead-URL');

        const response = await fetch(url, {
            headers: {Accept: 'text/html'},
            credentials: 'same-origin'
        });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const html = await response.text();
        if (!element.isConnected) return;
        if (!html.trim()) throw new Error('Leere MostRead-Antwort');

        // Initialisiert HX-GET-Filter und die bestehenden afterSettle-Handler
        // (u. a. Gelesen-/Gemerkt-Markierungen) auch beim ersten Nachladen.
        htmx.swap(element, html, {swapStyle: 'innerHTML', settleDelay: 20}, {
            afterSwapCallback: () => {
                if (!element.isConnected || !box.isConnected) return;
                box.hidden = false;
                box.style.removeProperty('display');
            }
        });
    } catch (error) {
        box.hidden = true;
        box.style.display = 'none';
        console.error('MostRead konnte nicht geladen werden:', error);
    } finally {
        element.removeAttribute('aria-busy');
    }
}

function initialisiereIwwMostRead(root) {
    if (root instanceof Element && root.matches(iwwMostReadSelector)) {
        iwwMostReadLoad(root);
    }
    root.querySelectorAll(iwwMostReadSelector).forEach(iwwMostReadLoad);
}

function iwwMostReadStart() {
    initialisiereIwwMostRead(document);
    if (typeof MutationObserver === 'undefined' || !document.body) return;

    new MutationObserver(mutations => {
        mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
            if (node instanceof Element) initialisiereIwwMostRead(node);
        }));
    }).observe(document.body, {childList: true, subtree: true});
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iwwMostReadStart, {once: true});
} else {
    iwwMostReadStart();
}

